import { ChangeDetectionStrategy, Component, inject, input, model } from '@angular/core';
import { Router } from '@angular/router';
import {
  SearchResultItemComponent,
  SearchResultRenderer,
  SOFT_SHELL_SAVE_LAST_VIEWED,
  SOFT_SHELL_SEARCH_DISMISS,
} from '@softapps/core';

@Component({
  selector: 'soft-artikelstamm-search-result',
  imports: [SearchResultItemComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(keydown.enter)': 'open(result())',
    '(click)': 'open(result())',
  },
  template: `
    @let item = result();
    <soft-search-result-item
      icon="fa-regular fa-database"
      [title]="item?.['5'] ?? item?.['4'] ?? ''"
      [meta]="meta(item)"
    />
  `,
})
export class ArtikelstammSearchResultComponent extends SearchResultRenderer<any> {
  override result = input.required<any>();
  override highlighted = input(false);
  override disabled = model(false);

  private readonly router = inject(Router);
  private readonly dismissSearchOverlay = inject(SOFT_SHELL_SEARCH_DISMISS);
  private readonly saveLastViewed = inject(SOFT_SHELL_SAVE_LAST_VIEWED, {
    optional: true,
  });

  meta(item: any): string {
    return [item?.['cartikelnummer'], item?.['3']].filter(Boolean).join(' · ');
  }

  async open(item: any): Promise<void> {
    if (!item) return;
    const id = item['25'] ?? item.id;
    this.saveLastViewed?.({
      key: String(id),
      number: String(item['cartikelnummer'] ?? ''),
      title: item['5'] ?? item['4'] ?? '',
      url: `/artikelstamm/${id}`,
    });
    this.dismissSearchOverlay();
    await this.router.navigate(['/artikelstamm', id], {
      fragment: 'allgemein',
    });
  }
}
